import {
  FETCH_GARAGES_DATA,
  FETCH_GARAGES_SUCCESS,
  FETCH_GARAGES_FAILURE,
  FETCH_GARAGES_EDIT_DATA,
  FETCH_GARAGES_EDIT_SUCCESS,
  FETCH_GARAGES_EDIT_FAILURE,
} from "./actionTypes";

export const fetchGaragesData = () => ({
  type: FETCH_GARAGES_DATA,
});

export const fetchGaragesSuccess = (data) => ({
  type: FETCH_GARAGES_SUCCESS,
  payload: data,
});

export const fetchGaragesFailure = (error) => ({
  type: FETCH_GARAGES_FAILURE,
  payload: error,
});

export const fetchGaragesEditData = (id) => ({
  type: FETCH_GARAGES_EDIT_DATA,
  payload: id,
});

export const fetchGaragesEditSuccess = (data) => ({
  type: FETCH_GARAGES_EDIT_SUCCESS,
  payload: data,
});

export const fetchGaragesEditFailure = (error) => ({
  type: FETCH_GARAGES_EDIT_FAILURE,
  payload: error,
});
